import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';

const NotAuthorized = () => {
  return (
    <div className='flex flex-1 items-center justify-center px-6 py-0'>
      <div className='max-w-lg w-full text-center'>
        {/* Icon */}
        <div className='mx-auto mb-8'>
          <div className='inline-flex'>
            <div className='w-32 h-32 rounded-2xl bg-gradient-to-br from-orange-100 to-red-100 flex items-center justify-center shadow-lg'>
              <LockClosedIcon className='w-16 h-16 text-orange-500' />
            </div>
          </div>
        </div>

        {/* Title */}
        <h1 className='text-4xl font-bold text-gray-900 mb-3'>Akses Ditolak</h1>

        {/* Description */}
        <p className='text-gray-500 mb-8 leading-relaxed'>
          Maaf, Anda tidak memiliki izin untuk mengakses halaman ini. Jika Anda merasa ini adalah
          kesalahan, silakan hubungi administrator untuk permintaan akses.
        </p>

        {/* Info Box */}
        <div className='mt-10 p-4 bg-blue-50 rounded-xl border border-blue-100'>
          <p className='text-sm text-blue-700'>
            <strong>Catatan:</strong> Setiap user memiliki hak akses yang berbeda-beda. Hak akses
            ditentukan oleh administrator berdasarkan peran masing-masing user.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;
